module.exports = __webpack_public_path__ + "static/shrieker-6a2fe64c8281565918710eeea7e798a2.jpg";